import React from "react"

import { ProjectPositionInput } from "widgets/inputs/project-position-input/ProjectPositionInput"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"
import { useProductPositionFormSelectionContext } from "../../contexts/ProductPositionFormSelectionContext"

export const ProductPositionPositionInput = React.memo(() => {
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoadingPositionOptions } = useProductPositionFormLoadingContext()
  const { positionOptions } = useProductPositionFormSelectionContext()
  const { hidePosition } = formOptions || {}

  if (hidePosition || isReadonly || !positionOptions) return null

  return (
    <ProjectPositionInput
      name="displayPosition"
      options={positionOptions}
      readonly={isReadonly}
      loading={isLoadingPositionOptions}
      disabled={isDisabled}
    />
  )
})
